import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { UntypedFormGroup } from '@angular/forms';
import { Locations } from 'src/app/_global/locations';
import { Suppliers } from 'src/app/_global/suppliers';
import { StoresManager } from 'src/app/_global/stores-manager';

@Component({
  selector: 'advanced-reorder-settings',
  templateUrl: './advanced-reorder-settings.component.html',
  styleUrls: ['./advanced-reorder-settings.component.scss']
})
export class AdvancedReorderSettingsComponent {
  @Input() item: any;

  configForm: UntypedFormGroup;
  imageUrl: string = environment.baseUrl + '/products/image/';

  constructor(public modal: NgbActiveModal,
    public locations: Locations,
    public suppliers: Suppliers,
    public stores: StoresManager) { }

  isOverstockedDisabled() {
    return Object.keys(this.item.overstockedStoresFormGroup.value).some(storeId => this.item.overstockedStoresFormGroup.value[storeId])
      || Object.keys(this.item.storesFormGroup.value).every(storeId => this.item.storesFormGroup.value[storeId]) ? null : true;
  }
}